import { ACCEPTED_FILE_TYPES } from "components/common/CreateProjectSheet/CreateProjectSheet.constants";

export const SCREENPLAY_EXTENSIONS = Array.from(new Set(Object.values(ACCEPTED_FILE_TYPES).flat()));

/** Same formats the create flow's own dropzone accepts, judged by extension. */
export const isAcceptedScreenplay = (file: Pick<File, "name">) => {
  const dot = file.name.lastIndexOf(".");
  if (dot < 0) return false;
  return SCREENPLAY_EXTENSIONS.includes(file.name.slice(dot).toLowerCase());
};

/** True while the user drags files (not text or links) over the window. */
export const isFileDrag = (event: DragEvent) =>
  Array.from(event.dataTransfer?.types ?? []).includes("Files");
